import styled from 'styled-components';

export const Root = styled.div<{ show: boolean }>`
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  z-index: 1000;
  padding: 12px 6px;

  ${({ show }) =>
    show
      ? `
        height: 150px;
        top: 0;
        transition: top, height 0.3s ease;
      `
      : `
        height: 0;
        top: 150px;
        transition: top 0s ease 0.3s, height 0.3s ease;
      `}

  &::-webkit-scrollbar-track {
    background: var(--color-primary);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: var(--color-secondary);
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: var(--scroll-bar-size);
    background: var(--color-primary);
  }

  @media screen and (max-width: 768px) {
  }
`;

export const Reels = styled.div`
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto;
`;

export const Reel = styled.div`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 160px;
  height: 100%;
  margin: 0 6px;
  display: inline-block;
  text-align: center;
  position: relative;
  overflow: hidden;
  border: 1px solid #000;
  background-color: rgba(0, 0, 0, 0.7);

  .loader {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    z-index: 0;

    span {
      background: none;
      animation: rotate 1s linear infinite;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    p {
      position: absolute;
      width: 100%;
      height: 100%;
      padding-top: 20px;
      text-align: center;
    }
  }
`;

export const Bar = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  z-index: 2;
  padding: 4px 0;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;

  span {
    width: 100%;
    font-size: 12px;
    text-align: start;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  i {
    font-size: 11px;
    cursor: pointer;
    margin: 0 2px;
    min-width: 14px;
  }
`;
